export default __webpack_public_path__ + "static/media/Lender.6a9c2a96.svg";